import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { CustomerAccountsEffects } from './customer-accounts.effects';
import { customerAccountsReducer } from './customer-accounts.reducer';
import { CUSTOMER_ACCOUNTS_FEATURE_KEY } from './customer-accounts.reducer';
import { CustomerAccountsFacade } from './customer-accounts.facade';
import { CustomerAccountsService } from './customer-accounts.service';

@NgModule({
    imports: [
        CommonModule,
        StoreModule.forFeature(CUSTOMER_ACCOUNTS_FEATURE_KEY, customerAccountsReducer),
        EffectsModule.forFeature([CustomerAccountsEffects])
    ],
    providers: [CustomerAccountsService, CustomerAccountsFacade]
})
export class CustomerAccountsModule {}
